import { render, staticRenderFns } from "./pl.vue?vue&type=template&id=082612af&scoped=true&lang=html&"
import script from "./pl.vue?vue&type=script&lang=js&"
export * from "./pl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082612af",
  null
  
)

export default component.exports